import { useInitialAnalyticsPosts } from '../hooks';
import { AnalyticsInstagramPostsTemplate } from './analytics-instagram-posts-template';

export const AnalyticsInstagramPosts = () => {
  const { mainSocialAccountId } = useInitialAnalyticsPosts({ socialMedia: 'instagram' });

  return <AnalyticsInstagramPostsTemplate mainSocialAccountId={mainSocialAccountId} />;
};
